<template>
	<div>
        <b-button @click.stop="handlingDownloadEventByPage" :variant="btn_variant" :class="d_none" :disabled="disabled">
            <slot></slot>
        </b-button> 

        <b-modal :id="'print_modal'+modal_id" size="lg" @show="handleShow()" @hide="handleClose()" hide-footer>
			<template v-slot:modal-title>
				<span v-if="isIE!=true">인쇄/다운로드</span>
				<span v-else>다운로드</span>
			</template>
			<div class="d-block text-center">
				<div v-if="print_ready!=true">
					<div class="align-middle">
						<b-spinner small class="mr-2" type="grow"></b-spinner>
						{{ msg }}
					</div>
				</div>
				<div v-else>
                    <p class="text-left fw-500"> {{$t(`PDF로 다운로드 하실 경우 아래 설명을 확인 후 진행해 주세요.`)}}</p>

                    <b-tabs content-class="bg-white pt-3 pb-4 mb-4">
                        <b-tab :title="$t(`크롬(Google Chrome) 사용중인 경우`)" active>
                            <b-img :src="$i18n.locale=='en'?'/images/how_to_print_chrome_en.png':'/images/how_to_print_chrome.png'" fluid style="max-width: 90%"></b-img>
                        </b-tab>
                        <b-tab :title="$t(`엣지(Microsoft Edge) 사용중인 경우`)">
                            <b-img :src="$i18n.locale=='en'?'/images/how_to_print_edge_en.png':'/images/how_to_print_edge.png'" fluid style="max-width: 90%"></b-img>
                        </b-tab>
                    </b-tabs>
					<div v-if="isIE!=true">
						<b-button v-print="print_target" variant="blue">PDF 인쇄 / 다운로드</b-button>
					</div>
					<div v-else>
						<b-button @click="pdf.save('company_report.pdf')" variant="blue">PDF 다운로드</b-button> 
					</div>
				</div>
			</div>
			<b-button  class="float-right" @click="cancel()" variant="dark">취소</b-button>
		</b-modal>
    </div>
</template>
<script>
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import html2PDF from 'jspdf-html2canvas';

// import NotoSansKRLightbase64 from '@/assets/fonts/Noto_Sans_KR_base64/NotoSansKR-Light.base64.txt';
// import NotoSansKRMediumbase64 from '@/assets/fonts/Noto_Sans_KR_base64/NotoSansKR-Medium.base64.txt';
// import NotoSansKRBoldbase64 from '@/assets/fonts/Noto_Sans_KR_base64/NotoSansKR-Bold.base64.txt';
// import NotoSansKRSemiBoldbase64 from '@/assets/fonts/Noto_Sans_KR_base64/NotoSansKR-SemiBold.base64.txt';
// import NotoSansKRRegularbase64 from '@/assets/fonts/Noto_Sans_KR_base64/NotoSansKR-Regular.base64.txt';
// import QuestionsForPrint from '@/components/print_to_pdf/QuestionsForPrint'
// import * as th from 'tree-helper'
// import * as ih from '@core_utils/util'

export default {
	name: 'pdf',
    components: {
        // QuestionsForPrint
    },
	props:{
        print_target: {
			type: String,
			required: true
		},
		project_code: {
			type: [String, Boolean],
			required: false
		},
        btn_variant: {
			type: String,
			default: 'dark-border'
		},
        d_none: {
			type: String,
			default: ''
		},
        disabled: {
			type: Boolean,
			default: false
		}
    },
	data () {
		return {
			propTitle: 'mypdf',
			print_ready: false,
			pdf: '',
			msg: this.$t(`PDF 파일 준비중... 최대 1분 정도 소요될 수 있습니다.`),
			is_printing: false,
			modal_id: Math.random()*1000
		}
    },
	computed: {},
	methods: {
		async handlingDownloadEventByPage () {
			console.log(`handlingDownloadEventByPage ~ `); 
			if (this.$route.name === 'ProjectProgress') {
				await this.downloadParticipationCompanyExcel()
			} else {
				await this.printStart()
			}
		},
		async downloadParticipationCompanyExcel () {
			try {
				// const path = process.env.VUE_APP_BACKENDHOST + '/download_project_status'
				const downloadedExcel = await this.$axios.get('/download_project_status', {
					params: { project_code: this.project_code },
					responseType: 'blob'
				})
				if (downloadedExcel.headers['content-length'] === '0') {
					return alert('프로젝트에 참여중인 기업이 없습니다.')
				}
				const fileObjectUrl = window.URL.createObjectURL(
				new Blob([downloadedExcel.data],
					{ type: downloadedExcel.headers['content-type'] }
				));
				const link = document.createElement('a');
				link.href = fileObjectUrl;
				link.style.display = 'none';
				link.setAttribute('download', `${this.project_code}.xlsx`);
				document.body.appendChild(link);
				link.click();
				link.remove();

				window.URL.revokeObjectURL(fileObjectUrl);
			} catch (error) {
				let error_message = null
				if (error.response) {
					const error_code = error.response.statusCode
					if (error_code === 400) error_message = '잘못된 요청입니다. 다시 시도해주세요.'
					else if (error_code === 404) error_message = '존재하지 않는 프로젝트입니다.'
				} else {
					error_message = '알 수 없는 오류가 발생했습니다. 기술팀에게 문의해주세요.'
				}
				alert(error_message)
			}
		},
		async printStart () {
			this.$bvModal.show('print_modal'+this.modal_id)

			if (this.isIE === true) {
				this.pdf = await this.makePDF2('#'+this.print_target) 
			}

			this.msg = '출력 준비가 완료되었습니다.'
            this.print_ready = true
		},
		async makePDF2 (sel) {
			// console.log(`makePDF2 ~ `);
			// console.log(` ~ sel => `, sel); 
			// const _report_contents = document.querySelectorAll(`#${sel} .report-page-contenet`)
			// // const _report_contents = document.querySelectorAll(`#${sel}`)
			// console.log(` ~ _report_contents => `, _report_contents); 
			const pdf = await html2PDF(_report_contents, {
				jsPDF: {
					// unit: 'pt',
					format: 'a4'
				},
				html2canvas: {
					scrollX: 0,
					scrollY: -window.scrollY,
					imageTimeout: 30000,
					// logging: true,
					useCORS: true,
					allowTaint: true,
					dpi: 300,
					letterRendering: true,
					scale: 2
				},
				imageType: 'image/jpeg',
				imageQuality: 1,
				margin: {
					top: 30,
					right: 30,
					bottom: 30,
					left: 30,
				},
				autoResize: true,
				success: (pdf) => {
					console.log(pdf);
					console.log(this.output)
					// window.open(pdf.output())
					pdf.save(this.output);
				}

			});
			console.log(` ~ pdf => `, pdf);
            this.is_printing = false
			return pdf
		},
		makePDF (sel) {
			window.html2canvas = html2canvas //Vue.js 특성상 window 객체에 직접 할당해야한다.
			// let that = this
			let pdf = new jsPDF('p', 'mm', 'a4')
			let canvas = pdf.canvas
			const pageWidth = 210 //캔버스 너비 mm
			const pageHeight = 297 //캔버스 높이 mm
			canvas.width = pageWidth

            let ele = document.querySelector(sel)
			let width = ele.offsetWidth // 셀렉트한 요소의 px 너비
			let height = ele.offsetHeight // 셀렉트한 요소의 px 높이
			let imgHeight = pageWidth * height/width // 이미지 높이값 px to mm 변환

			if (!ele){
				console.warn(sel + ' is not exist.')
				return false
			}

            return html2canvas(ele)
				.then(function (canvas) {
					let position = 0
					const imgData = canvas.toDataURL('image/png')
					pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight, undefined, 'slow')

					// Paging 처리
					let heightLeft = imgHeight //페이징 처리를 위해 남은 페이지 높이 세팅.
					heightLeft -= pageHeight
					while (heightLeft >= 0) {
						position = heightLeft - imgHeight
						pdf.addPage();
						pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight)
						heightLeft -= pageHeight
					}
					
					return pdf
			})
		},
		cancel () {
			this.$bvModal.hide('print_modal'+this.modal_id)
		},
		handleShow () {
			this.is_printing = true
			this.$emit('modal-opened')
		},
		handleClose () {
			this.is_printing = false
			this.$emit('modal-closed')
		},
	},
}
</script>
<style scoped>
.printing{
	display: block;
}

.not_printing{
	display: none;
}
</style>
